import PropTypes from "prop-types";
// @mui
import {
	Table,
	TableRow,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	Typography,
	Paper,
} from "@mui/material";

// ----------------------------------------------------------------------

QuarterlyStatsTable.propTypes = {
	data: PropTypes.object,
	selectedQuarter: PropTypes.number,
};

export default function QuarterlyStatsTable({ data, selectedQuarter }) {
	const { visitStats, housingStats } = data;

	// Mapping to determine which month keys and labels to show based on the quarter
	const quarterMonthMap = {
		1: { ids: [4, 5, 6], names: ["April", "May", "June"] },
		2: { ids: [7, 8, 9], names: ["July", "August", "September"] },
		3: { ids: [10, 11, 12], names: ["October", "November", "December"] },
		4: { ids: [1, 2, 3], names: ["January", "February", "March"] },
	};

	const currentQuarterInfo = quarterMonthMap[selectedQuarter];
	const isSelected = (q) => q === selectedQuarter;

	return (
		<TableContainer component={Paper} sx={{ minWidth: 800, mt: 3 }}>
			<Typography variant="h6" sx={{ p: 2, bgcolor: "background.neutral" }}>
                Housing Tenure / Joined members / Visits per Quarter
			</Typography>
			<Table size="small">
				<TableHead>
					<TableRow>
						<TableCell>Housing Tenure</TableCell>
						<TableCell align="center">Joined (Q{selectedQuarter})</TableCell>

						{/* DYNAMIC MONTH COLUMNS */}
						{currentQuarterInfo.names.map((monthName) => (
							<TableCell
								key={monthName}
								align="right"
								sx={{ fontWeight: "bold", color: "primary.main" }}
							>
								{monthName}
							</TableCell>
						))}

						<TableCell
							align="right"
							sx={{
								fontWeight: isSelected(1) ? "bold" : "normal",
								bgcolor: isSelected(1) ? "action.hover" : "none",
							}}
						>
                            Q1 Totals
						</TableCell>
						<TableCell
							align="right"
							sx={{
								fontWeight: isSelected(2) ? "bold" : "normal",
								bgcolor: isSelected(2) ? "action.hover" : "none",
							}}
						>
                            Q2 Totals
						</TableCell>
						<TableCell
							align="right"
							sx={{
								fontWeight: isSelected(3) ? "bold" : "normal",
								bgcolor: isSelected(3) ? "action.hover" : "none",
							}}
						>
                            Q3 Totals
						</TableCell>
						<TableCell
							align="right"
							sx={{
								fontWeight: isSelected(4) ? "bold" : "normal",
								bgcolor: isSelected(4) ? "action.hover" : "none",
							}}
						>
                            Q4 Totals
						</TableCell>
						<TableCell align="right" sx={{ fontWeight: "bold" }}>
                            Annual Total
						</TableCell>
					</TableRow>
				</TableHead>

				<TableBody>
					{visitStats.map((row, index) => {
						const housingInfo = housingStats.find(
							(h) => h.housing_name === row.housing_tenure
						);

						return (
							<TableRow key={index} hover>
								<TableCell component="th" scope="row">
									{row.housing_tenure}
								</TableCell>

								{/* UPDATED JOINED CELL: Now picks the specific joined_q property */}
								<TableCell
									align="center"
									sx={{ color: "primary.main", fontWeight: "bold" }}
								>
									{housingInfo ? (housingInfo[`joined_q${selectedQuarter}`] || 0) : 0}
								</TableCell>

								{/* DYNAMIC MONTH DATA CELLS */}
								{currentQuarterInfo.ids.map((monthId) => (
									<TableCell key={monthId} align="right">
										{row[`month_${monthId}`] || 0}
									</TableCell>
								))}

								<TableCell
									align="right"
									sx={{
										bgcolor: isSelected(1) ? "action.hover" : "none",
										opacity: isSelected(1) ? 1 : 0.6,
									}}
								>
									{row.q1_totals}
								</TableCell>

								<TableCell
									align="right"
									sx={{
										bgcolor: isSelected(2) ? "action.hover" : "none",
										opacity: isSelected(2) ? 1 : 0.6,
									}}
								>
									{row.q2_totals}
								</TableCell>

								<TableCell
									align="right"
									sx={{
										bgcolor: isSelected(3) ? "action.hover" : "none",
										opacity: isSelected(3) ? 1 : 0.6,
									}}
								>
									{row.q3_totals}
								</TableCell>

								<TableCell
									align="right"
									sx={{
										bgcolor: isSelected(4) ? "action.hover" : "none",
										opacity: isSelected(4) ? 1 : 0.6,
									}}
								>
									{row.q4_totals}
								</TableCell>

								<TableCell align="right" sx={{ fontWeight: "bold" }}>
									{row.annual_total}
								</TableCell>
							</TableRow>
						);
					})}
				</TableBody>
			</Table>
		</TableContainer>
	);
}